module.exports = __webpack_public_path__ + "static/media/allalerts_hover.ff98fdbe.svg";